import React from "react";
interface ClientTestimonialMasonaryData {
    imageUrl: string;
    description: string;
    author: string;
    position?: string;
}
const TwoCardTestimonial: React.FC = () => {
    const clientMasonaryData: ClientTestimonialMasonaryData[] = [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/visa-offer/livingstone-logo.png",
            description:
                "Gallabox has significantly helped us in streamlining our entire communication. WhatsApp is the most common platform for communication, this makes Gallabox a very powerful tool! We were able to make WhatsApp a central communication channel for our company. ",
            author: "Chirag B",
            position: "Founder of LivingStone Stays",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/visa-offer/jobstar.png",
            description:
                "Awesome support team! Gallabox's Customer Success team is very responsive and ready to help if we have any questions. This is a huge differentiator for us since we deal with hundreds of live customer conversations and timely support is needed.",
            author: "A. Kamalahasan",
            position: "Managing Director for Jobstar",
        },
    ];
    return (
        <div className="flex gap-7 justify-center flex-wrap" style={{ backgroundColor: "#FFED82", padding: "68px 10px" }}>
            {clientMasonaryData?.map((each: any, index: number) => (
                <div key={index} className="two-card-testimonial p-7 flex flex-col h-full justify-between bg-white" style={{ width: "100%", maxWidth: "584px" }}>
                    <div className="">
                        <div className={`${index === 1 ? "w-16" : "w-36"} flex pb-2`}>
                            <img src={each.imageUrl} alt="client-logo" />
                        </div>
                        <p className="text-lg font-normal text-gray-700">{each.description}</p>
                    </div>
                    <div className="mb-3">
                        <p className="font-bold" style={{ fontSize: "22px" }}>
                            {each.author}
                        </p>
                        <p className="font-normal text-base text-grey-700" style={{ height: "18px" }}>
                            {each.position}
                        </p>
                    </div>
                </div>
            ))}
        </div>
    );
};
export default TwoCardTestimonial;
